import { useState } from "react";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";

const round = (value) => (Number.isFinite(value) ? Math.round(value) : 0);
const round1 = (value) => Math.round(value * 10) / 10;
const formatDate = (value) => new Date(value).toLocaleDateString("fr-FR", { day: "numeric", month: "long" });

const mean = (rows) => (rows.length ? rows.reduce((sum, row) => sum + (row.value || 0), 0) / rows.length : 0);

const computeVariation = (data, unit) => {
  if (!data || data.length < 2) return null;
  const mid = Math.floor(data.length / 2);
  const first = mean(data.slice(0, mid));
  const second = mean(data.slice(mid));
  if (unit === "pt") return round1(second - first);
  return first > 0 ? round1(((second - first) / first) * 100) : null;
};

const RateTile = ({ label, subtitle, value, data, color = "#165DFB", suffix = "%", format, height = 56, variationUnit = "%", goodWhenUp = true }) => {
  const [active, setActive] = useState(null);
  const rawValue = active ? active.value : value;
  const caption = active ? formatDate(active.date) : subtitle;
  const variation = computeVariation(data, variationUnit);

  return (
    <div className="flex flex-col rounded-xl border border-gray-200 bg-white p-5">
      <p className="truncate text-xs font-medium text-gray-500">{label}</p>
      <p className="mt-0.5 truncate text-[11px] text-gray-400">{caption}</p>
      <div className="mt-2 flex items-baseline gap-2">
        <p className="text-3xl font-semibold tabular-nums text-gray-900">
          {format ? (
            format(rawValue)
          ) : (
            <>
              {round(rawValue)}
              <span className="ml-0.5 text-lg font-medium text-gray-400">{suffix}</span>
            </>
          )}
        </p>
        {variation !== null && variation !== undefined && (
          <span className={`shrink-0 text-xs font-medium tabular-nums ${variation === 0 ? "text-gray-400" : variation > 0 === goodWhenUp ? "text-green-600" : "text-red-500"}`}>
            {variation > 0 ? "+" : variation < 0 ? "−" : ""}
            {Math.abs(variation)}
            {variationUnit === "pt" ? " pt" : " %"}
          </span>
        )}
      </div>
      <div className="mt-auto pt-4">
        <ResponsiveContainer width="100%" height={height}>
          <AreaChart
            data={data}
            margin={{ top: 2, right: 0, left: 0, bottom: 0 }}
            onMouseMove={(state) => (state?.activePayload?.length ? setActive({ value: state.activePayload[0].value, date: state.activeLabel }) : undefined)}
            onMouseLeave={() => setActive(null)}
          >
            <XAxis dataKey="date" hide />
            <Tooltip content={() => null} cursor={{ stroke: color, strokeWidth: 1, strokeDasharray: "3 3" }} />
            <Area type="monotone" dataKey="value" stroke={color} strokeWidth={1.5} fill={color} fillOpacity={0.12} dot={false} activeDot={{ r: 3, fill: color, strokeWidth: 0 }} isAnimationActive={false} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RateTile;
